
import { BaseBackgroundEffect } from '@/render/background/BaseBackgroundEffect';
import { BackgroundContext } from '@/render/background/BackgroundEffect';

export class DeepSpaceBackdrop extends BaseBackgroundEffect {
    private stars: {x: number, y: number, size: number, brightness: number}[] = [];

    private init(bc: BackgroundContext) {
        if (this.stars.length > 0) return;
        for (let i = 0; i < 300; i++) {
            this.stars.push({
                x: Math.random() * bc.width,
                y: Math.random() * bc.height,
                size: Math.random() * 1.5,
                brightness: Math.random()
            });
        }
    }

    public render(bc: BackgroundContext): void {
        const { ctx, width, height, time, config } = bc;
        this.init(bc);

        // Slow moving nebula essence
        const grad = ctx.createRadialGradient(
            width / 2 + Math.cos(time * 0.1) * width * 0.2,
            height / 2 + Math.sin(time * 0.1) * height * 0.2,
            0,
            width / 2, height / 2, width
        );
        grad.addColorStop(0, this.getSecondaryColor(bc));
        grad.addColorStop(1, this.getPrimaryColor(bc));
        
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, width, height);

        // Draw stars with subtle flicker
        ctx.fillStyle = '#ffffff';
        this.stars.forEach(s => {
            const flicker = 0.7 + 0.3 * Math.sin(time * 3 + s.brightness * 10);
            ctx.globalAlpha = flicker * 0.8;
            ctx.beginPath();
            ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2);
            ctx.fill();
        });
        
        // Add a very faint glow in the center
        const glow = ctx.createRadialGradient(width/2, height/2, 0, width/2, height/2, width/2);
        glow.addColorStop(0, 'rgba(255, 255, 255, 0.05)');
        glow.addColorStop(1, 'transparent');
        ctx.fillStyle = glow;
        ctx.fillRect(0, 0, width, height);

        ctx.globalAlpha = 1.0;
    }
}
